export default "__VITE_ASSET__70f39c0a__"